// Wire shape between the PWA and the Worker. The Worker is a thin CORS/secret
// bridge; the app sends the full session plus a pre-rendered human summary so the
// Worker stays dumb (it just maps to Notion properties + page body).

import type { Exercise, Session, SuggestedAdjustment, BodyMeasurement } from '../domain/types';
import { sessionSummary } from './format';

export interface SyncSessionDTO {
  session: Session;
  summary: string;
}

// Measurements are pure properties (no page body), so the DTO is just the record.
export interface SyncMeasurementDTO {
  measurement: BodyMeasurement;
}

export interface SyncRequest {
  sessions?: SyncSessionDTO[];
  measurements?: SyncMeasurementDTO[];
}

export interface SyncResponse {
  ok: boolean;
  upserted: string[];
  errors: { sessionId: string; error: string }[];
  // Present when the request included measurements.
  measurementsUpserted?: string[];
  measurementErrors?: { measurementId: string; error: string }[];
}

export interface CoachingDTO {
  sessionId: string;
  date: string;
  coaching: string | null;
  suggestedAdjustments: SuggestedAdjustment[] | null;
  coachedAt: string | null;
}

export interface CoachingResponse {
  ok: boolean;
  coaching: CoachingDTO[];
}

export function toSyncDTO(session: Session, exById: Map<string, Exercise>): SyncSessionDTO {
  return { session, summary: sessionSummary(session, exById) };
}

export function toSyncMeasurementDTO(measurement: BodyMeasurement): SyncMeasurementDTO {
  return { measurement };
}
